/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { HiOutlineMenuAlt2 } from 'react-icons/hi';
import { IoPricetagOutline } from 'react-icons/io5';
import StarIcon from '@mui/icons-material/Star';
import './contactverifier.css';
import parse from 'html-react-parser';
import { LuContact } from 'react-icons/lu';
import { connect } from 'react-redux';
import Card from 'react-bootstrap/Card';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import axios from 'axios';
import { TbWorld, TbAddressBook, TbMapPinCode, TbBrandLinkedin, TbBriefcase } from 'react-icons/tb';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import InfiniteScroll from 'react-infinite-scroll-component';
import PermContactCalendarOutlinedIcon from '@mui/icons-material/PermContactCalendarOutlined';
import Key from '../../clientVariables.json';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Grid from '@mui/material/Grid';

import Button from 'react-bootstrap/Button';
import { toast } from 'react-toastify';
import moment from 'moment';
import ToastMessage from '../../components/ToastMessage';
import Search from '../Searchcontact';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ContactActivity from './ContactActivity';
import UpdateCompanyContact from './UpdateCompanyContact';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useSelector } from 'react-redux';
import { companiesManagementSelector } from './redux/selector';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
export const CompanyJobDetail = ({ jobDetails, showContact }) => {
  const scrollRef = useRef(null);
  const [email, setEmail] = useState('');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorE2, setAnchorE2] = React.useState(null);
  const open = Boolean(anchorEl);
  const open2 = Boolean(anchorE2);
  const userReducer = useSelector(state => state.UserReducer.user);

  useEffect(() => { }, []);
  console.log(userReducer)
  return (
    <div>
      <Card style={{ height: '47px' }}>
        <div className="row">
          <div className="col-12">
            <div style={{ float: 'right' }}>
              <p onClick={() => showContact()}>
                <Tooltip title="Contacts">
                  <IconButton>
                    <LuContact
                      style={{
                        fontSize: '20px',
                        marginTop: '2px',
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </p>
            </div>
          </div>
        </div>
      </Card>

      {jobDetails !== null && jobDetails !== undefined ? (
        <Card style={{ padding: '15px', overflowY: 'scroll', height: '567px' }} className="infinityscroll">
          <Grid container spacing={1}>
            <Grid item xs={1}>
              <Avatar style={{ backgroundColor: 'rgb(169, 169, 169)' }}>
                <BusinessCenterIcon />
              </Avatar>
            </Grid>

            <Grid item xs={9}>
              <div style={{ marginLeft: '16px' }}>
                <h4 style={{ fontWeight: '600', fontSize: '20px' }}>
                  {jobDetails?.title ? jobDetails.title : <Skeleton width={500} />}
                </h4>

                <p style={{ fontSize: '12px', display: 'flex' }}>
                  <span>Location : {jobDetails?.location ? jobDetails.location : 'N/A'}</span>
                  &nbsp;|&nbsp;
                  <span>Job Type : {jobDetails?.jobtypeName ? jobDetails.jobtypeName : 'N/A'}</span>
                </p>
                {/* <Label>
                  {jobDetails?.source ? jobDetails.source : 'N/A'}
                  <LabelDetail>{jobDetails?.source_name ? jobDetails.source_name : 'N/A'}</LabelDetail>
                </Label> */}


              </div>
            </Grid>
            {parseInt(userReducer.user_type) === 8 ?
              <Grid item xs={2}>
                <span title={jobDetails?.source === 'WSJ' ? 'Web Scrapping Job - ' + jobDetails.source_name : jobDetails?.source === 'OSJ' ? 'Outlook Scrapping Job - ' + jobDetails.source_name : jobDetails?.source === 'JNP' ? 'Jobsnprofiles Posted Job - ' + jobDetails.source_name : jobDetails?.source === 'CEIPAL' ? 'CEIPAL Posted Job - ' + jobDetails.source_name : 'N/A'}>
                  <Chip label={jobDetails?.source ? jobDetails.source_name + ' | ' + jobDetails.source  : 'N/A'} />
                </span>
              </Grid> : ""}
          </Grid>
          <div>
            {/* <span className="job-description" style={{ fontSize: '12px' }}>
              {jobDetails?.description !== undefined && typeof jobDetails.description === 'string' ? (
                parse(jobDetails.description)
              ) : (
                <Skeleton count={70} />
              )}
            </span> */}
            <span className="job-description" style={{ fontSize: '12px' }}>
              {jobDetails?.description !== null && jobDetails?.description !== undefined && jobDetails?.description && typeof jobDetails?.description === 'string' ? (
                parse(jobDetails?.description)
              ) : jobDetails?.description === null || jobDetails?.description === undefined ? "N/A" : (
                <Skeleton count={70} />
              )}
            </span>

            {jobDetails?.skills && (
              <span style={{ fontSize: '12px' }}>
                <p style={{ fontWeight: '700' }}>Skills</p>
                {jobDetails.skills}
              </span>
            )}
          </div>
        </Card>
      ) : (
        <center>
          <Skeleton />
          <Skeleton count={100} />
        </center>
      )}
    </div>
  );
};
export default CompanyJobDetail;
